import React from 'react';
import { FaClock, FaTrophy, FaDollarSign } from 'react-icons/fa';
import { ReceiptFrequencyResponse } from '../../types';

interface StatCardsProps {
  data: ReceiptFrequencyResponse;
}

const DAY_LABELS: Record<string, string> = {
  Monday: 'Lunes', Tuesday: 'Martes', Wednesday: 'Miércoles',
  Thursday: 'Jueves', Friday: 'Viernes', Saturday: 'Sábado', Sunday: 'Domingo',
};

const StatCards: React.FC<StatCardsProps> = ({ data }) => {
  const topFreq = data.rankings.byFrequency[0];
  const topAmt = data.rankings.byTotalAmount[0];

  const fmtCurrency = (v: number) => `$${v.toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;
  const fmtTime = (mins: number) => {
    const r = Math.round(mins);
    if (r >= 60) { const h = Math.floor(r / 60), m = r % 60; return m === 0 ? `${h} ${h === 1 ? 'hora' : 'horas'}` : `${h} ${h === 1 ? 'hora' : 'horas'} ${m} min`; }
    return `${r} min`;
  };

  const CARDS = [
    { icon: FaClock, iconClass: '', label: 'Tiempo Promedio General', value: fmtTime(data.overallAverageTimeToPayMinutes) },
    { icon: FaTrophy, iconClass: 'mp-stat-card-icon-amber', label: 'Mayor Frecuencia', value: `${topFreq.count} recibos`, subtitle: `${DAY_LABELS[topFreq.day]} • ${topFreq.hourRange}:00` },
    { icon: FaDollarSign, iconClass: 'mp-stat-card-icon-green', label: 'Mayor Ingreso', value: fmtCurrency(topAmt.totalAmount), subtitle: `${DAY_LABELS[topAmt.day]} • ${topAmt.hourRange}:00` },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {CARDS.map((c) => (
        <div key={c.label} className="mp-stat-card">
          <div className={`mp-stat-card-icon ${c.iconClass}`}><c.icon /></div>
          <div>
            <div className="mp-stat-card-label">{c.label}</div>
            <div className="mp-stat-card-value">{c.value}</div>
            {c.subtitle && <div className="mp-stat-card-subtitle">{c.subtitle}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;
